import {
  DateTime
} from "./chunk.JAWPSPJ3.js";

// src/utilities/date-utils.ts
function getDateFromDateInput(input) {
  if (input.type !== "date")
    return void 0;
  if (!input.value)
    return void 0;
  const parts = input.value.split("-");
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);
  if (year < 1e3)
    return void 0;
  return new Date(year, month, day);
}
function formatForDateInput(date) {
  if (!date)
    return void 0;
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return DateTime.utc(year, month, day).toISODate();
}
function getCurrentCalendarDate() {
  return getCalendarDate(new Date());
}
function isValidDate(date) {
  return date && date instanceof Date && !isNaN(date.valueOf()) || false;
}
function formatDate(date) {
  return (date == null ? void 0 : date.toLocaleDateString()) || "";
}
function getCalendarDate(date) {
  date = new Date(date);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  return new Date(year, month, day);
}
function getEndOfPreviousDate(date) {
  if (!date)
    return void 0;
  if (!isValidDate(date))
    return void 0;
  date = getCalendarDate(date);
  const timestamp = date.valueOf() - 1e3;
  return new Date(timestamp);
}
function getEndOfDate(date) {
  if (!date)
    return void 0;
  if (!isValidDate(date))
    return void 0;
  date = getCalendarDate(date);
  const secondsPerDay = 24 * 60 * 60 * 1e3;
  const timestamp = date.valueOf() + secondsPerDay - 1;
  return new Date(timestamp);
}
function existInRange(min, max, date) {
  const value = date.valueOf();
  return value >= min.valueOf() && value <= max.valueOf();
}

export {
  getDateFromDateInput,
  formatForDateInput,
  getCurrentCalendarDate,
  isValidDate,
  formatDate,
  getCalendarDate,
  getEndOfPreviousDate,
  getEndOfDate,
  existInRange
};
